import {Component, Input, OnInit} from '@angular/core';
import { ModalController, ToastController, LoadingController, AlertController } from '@ionic/angular';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SearchCountryField, CountryISO } from 'ngx-intl-tel-input';

import { AuthenticationService } from '../../services/authentication/authentication.service';
import { ApiService } from '../../services/api/api.service';
import { SharingService } from '../../services/sharing/sharing.service';
import { GlobalVariables } from '../../common/global-variables';

@Component({
  selector: 'app-send',
  templateUrl: './send.page.html',
  styleUrls: ['./send.page.scss'],
})
export class SendPage implements OnInit {

  @Input() transaction: any;
  @Input() payload: any;

  vendorSettings: any;
  deviceInfo: any;

  info: any;
  loaderToShow: any;
  sendForm: any;
  notificationMethod = 'email';
  tokenSent = false;

  separateDialCode = true;
  SearchCountryField = SearchCountryField;
  //TooltipLabel = TooltipLabel;
  CountryISO = CountryISO;
  preferredCountries: CountryISO[] = [
    CountryISO.Botswana,
    CountryISO.Liberia,
    CountryISO.Namibia,
    CountryISO.Mozambique,
    CountryISO.SouthAfrica,
    CountryISO.Kenya,
    CountryISO.Nigeria,
    CountryISO.Uganda
  ];

  constructor(private modalController: ModalController, private formBuilder: FormBuilder,
              public loadingController: LoadingController, public toastController: ToastController,
              public api: ApiService, private sharingService: SharingService, private globals: GlobalVariables) {
      this.sendForm = this.formBuilder.group({
        phone: [undefined, Validators.required ]
      });
  }

  ngOnInit() {
    this.deviceInfo = this.globals.deviceInfo;
    this.vendorSettings = this.globals.vendorSettings;
    this.selectNotificationMethod('email');
  }

  sendToken() {
    

    // this.showLoader('Sending Utility token...');
    const phone = this.sendForm.value.phone;
    if (this.notificationMethod === 'sms') {
      // add phone number to payload
      this.payload.Cellno = phone.internationalNumber;
      this.sharingService.sendSMS(this.transaction.data, phone.internationalNumber,
                                  this.deviceInfo.useSMSGateway, this.payload);
    } else if ( this.notificationMethod === 'whatsapp') {
      this.sharingService.sendWhatsapp(this.transaction.data, phone.internationalNumber);
    } else if ( this.notificationMethod === 'telegram') {
      this.sharingService.sendTelegram(this.transaction.data, phone.internationalNumber);
    } else if (this.notificationMethod === 'email') {

      const endpoint = this.globals.deviceInfo.remoteServer + 'SendTokenReceipt';
      this.payload.Recipient = this.sendForm.value.emailAddress;
      this.payload.IEMI = this.deviceInfo.IMEI;
      this.payload.Mode = "email";
    
      this.sharingService.sendEmail(endpoint,this.payload);
    } else {
      this.sharingService.sendOther(this.transaction.data);
    }
  }

  // Change Notification Method
  selectNotificationMethod(method) {
    this.notificationMethod = method;
    // re-render the Vend form Based on which Notification method is used
    if (method === 'email') {
      this.sendForm = this.formBuilder.group({
        emailAddress: ['', [Validators.email, Validators.required]]
      });
    } else {
      this.sendForm = this.formBuilder.group({
        phone: ['', Validators.required ]
      });
    }
  }

  showLoader(displayMessage) {
    this.loaderToShow = this.loadingController.create({
      message: displayMessage
    }).then((res) => {
      res.present();

      res.onDidDismiss().then((dis) => {
        // console.log('Loading dismissed!');
      });
    });
    // this.hideLoader();
  }

  hideLoader() {
    setTimeout(() => {
      this.loadingController.dismiss();
    }, 500);
  }

  async closeModal() {
    const onClosedData = {};
    await this.modalController.dismiss(onClosedData);
  }

  async presentToast(msg, color) {
    const toast = await this.toastController.create({
      message: msg,
      duration: 2000,
      position: 'bottom',
      color
    });
    toast.present();
  }

}
